import { FiltersMobileDrawer } from '../mobile/FiltersMobileDrawer';
import React from 'react';
import { useSelector } from 'react-redux';
import { getFromPricePackagesHasAppliedFilters } from '@state/search-results';
import { Filters } from '@model/iceberg';
import { FiltersSideBarContainer } from './FiltersSideBarContainer';

export interface FiltersMobileDrawerContainerProps {
  onClose: () => void;
  open: boolean;
  count: number;
  onResetFilters: () => void;
  onFiltersChange: (payload: Array<Filters>) => void;
}

export const FiltersMobileDrawerContainer = (props: FiltersMobileDrawerContainerProps) => {
  const { onResetFilters, onFiltersChange, count } = props;
  const hasAppliedFilters: boolean = useSelector(getFromPricePackagesHasAppliedFilters);
  return (
    <FiltersMobileDrawer
      {...props}
      hasAppliedFilters={hasAppliedFilters}
      onReset={onResetFilters}
      count={count}
      renderFilters={(props: any) => (
        <FiltersSideBarContainer {...props} onFiltersReset={onResetFilters} onFiltersChange={onFiltersChange} />
      )}
    />
  );
};
